
import { Component, Vue } from "vue-property-decorator"
import { Formatting } from "../util/formatting"
const dateFormat = new Formatting.DateFormatting()

import CountUnreadMessages from "../graphql/messages/countUnreadMessages.graphql"

@Component({
    apollo: {
        countUnreadMessages: {
            query: CountUnreadMessages,
            pollInterval: 30000
        }
    }
})
export default class NotificationsWidget extends Vue {
    countUnreadMessages?:any

    refresh() {
        console.log("refresh my notifications")
        if (this.$apollo.queries.countUnreadMessages && typeof this.$apollo.queries.countUnreadMessages.refetch == "function")
            this.$apollo.queries.countUnreadMessages.refetch()
    }
}
